import { useState, useRef } from "react"
import useApp from 'hooks/useApp'
import { Layer, SecureKeypad } from "components"
import { useNavigate } from "react-router-dom"
import Lib from 'library'
import { showChangePasswordLayerState } from 'views/setting/cert/states'
import { useRecoilState } from 'recoil'
import Native from 'library/native'

const ChangePasswordLayer = () => {

	const [showChangePasswordLayer, setShowChangePasswordLayer] = useRecoilState(showChangePasswordLayerState)

	//#region Variables
	const App = useApp()
	const navigate = useNavigate()
	const [title, setTitle] = useState("비밀번호를 입력해주세요.")
	const pass1 = useRef()
	const pass2 = useRef()

	const callback = module => {
		//console.log('ChangePasswordLayer...');

		const info = module.get_sessionInfo()
		if (typeof pass1.current === "undefined") {
			pass1.current = info
			setTitle("비밀번호를 다시 한번 입력해주세요.")
			module.refresh()
		} else {
			pass2.current = info

			Lib.post("/api/more/myinfo/upd/pw", {
				// pw: module.get_input(),
				// pwRe: module.get_input(),
				secId: pass1.current.sessionId,
				secId2: pass2.current.sessionId,
				secInput: pass1.current.input,
				secInput2: pass2.current.input,
				secToken: pass1.current.secToken,
				secToken2: pass2.current.secToken,
			}, () => {
				console.log("sucess")

				// module.close()
				if (App.user && App.user.mbId) {

					Native.execute("AppManager", "setAuthenticate", result => {
						const json = JSON.parse(result)
						if (json.result !== "Success") console.error(decodeURI(json.result))
					}, { userid: App.user.mbId })
				}
				App.showAlert({
					msg: "비밀번호가 변경되었습니다.<br />변경된 비밀번호로 다시 로그인해 주세요.",
					onOk: () => {
						module.close()
						App.logout(() => {
							App.closeAllLayers()
							navigate("/member/login")
						})
					}
				})
			}, () => { // 실패시
				console.log("failed")

				module.refresh()
				setTitle("비밀번호를 입력 해 주세요.")
				pass1.current = undefined
				pass2.current = undefined
			})
		}
	}


	// const callback = module => {
	// 	const info = module.get_sessionInfo()
	// 	if (!pass1.current) {
	// 		pass1.current = info
	// 		setTitle("비밀번호를 다시 한번 입력해주세요.")
	// 		module.refresh()
	// 	} else {
	// 		pass2.current = info
	// 		let url
	// 		if (reset) {
	// 			url = `/api/mb/login/upd/pw`
	// 		} else {
	// 			url = `/api/more/myinfo/upd/pw`
	// 		}
	// 		Lib.post(url, {
	// 			mbId: App.user?.mbId,
	// 			secId: pass1.current.sessionId,
	// 			secToken: pass1.current.secToken,
	// 			secInput: pass1.current.input,
	// 			secId2: pass2.current.sessionId,
	// 			secToken2: pass2.current.secToken,
	// 			secInput2: pass2.current.input,
	// 		}, result => {
	// 			App.showAlert({
	// 				msg: "비밀번호가 변경되었습니다.<br />변경된 비밀번호로 다시 로그인해 주세요.",
	// 				onOk: () => {
	// 					// module.close()
	// 					App.logout(() => {
	// 						setShowChangePasswordLayer(false)
	// 						setShowCertLayer(false)
	// 						setShowSettingLayer(false)
	// 					})
	// 				}
	// 			})
	// 		})
	// 	}
	// }

	return (
		<Layer show={showChangePasswordLayer} closeLayer={() => setShowChangePasswordLayer(false)}>
			<div className="padding">
				{/* <input type="hidden" id="input1" /> */}
				<SecureKeypad callback={callback} title={title} autoClose={false} />
			</div>
		</Layer>
	)
}

export default ChangePasswordLayer
